module.exports = __webpack_public_path__ + "img/c04_unitmerchanttransport_Normal_ua.0272f94f.webp";